module.exports = __webpack_public_path__ + "img/chinesecompany182.8c91f838.png";